import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical, faXmark } from "@fortawesome/free-solid-svg-icons";

/**
 * DS SideMenuItem — figma 340:7156 "side menu" (사이드메뉴 선택된 항목 row).
 *
 * white bg, border-bottom 1px Border/Light, padding y=16 px=0, gap 24
 * Left: drag handle 20×20
 * Center: detail (gap 12 column)
 *   - title: Pretendard SemiBold 14/22 Text/Primary
 *   - options: chip(s), each = BG/Paper, padding 8×4, radius 6, Regular 14/22 Text/Primary
 * Right: delete X 24×24
 *
 * @param {object} props
 * @param {string} props.name
 * @param {string[]} [props.options]
 * @param {React.ReactNode} [props.dragHandle]
 * @param {() => void} [props.onDelete]
 */
const DSSideMenuItem = ({ name, options = [], dragHandle, onDelete }) => {
  return (
    <div className="ds-sidemenu-item">
      {dragHandle || (
        <span className="ds-sidemenu-item__drag" aria-hidden>
          <FontAwesomeIcon icon={faGripVertical} />
        </span>
      )}
      <div className="ds-sidemenu-item__detail">
        <div className="ds-sidemenu-item__title">{name}</div>
        {options.length > 0 && (
          <div className="ds-sidemenu-item__options">
            {options.map((opt, idx) => (
              <span key={`${opt}-${idx}`} className="ds-sidemenu-item__option">
                {opt}
              </span>
            ))}
          </div>
        )}
      </div>
      {onDelete && (
        <button
          type="button"
          className="ds-sidemenu-item__close"
          onClick={onDelete}
          aria-label="삭제"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      )}
    </div>
  );
};

export default React.memo(DSSideMenuItem);
